import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';

export default class ApprovalInstanceFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.approvalTag = '';
		this.approvalConfigurationId  = '';
		this.approvalConfigurationName = '';
		this.approvalConfigurationInstanceId  = '';
		this.approvalConfigurationInstanceName = '';
		this.approvalTypeId  = '';
		this.approvalTypeName = '';
		this.currentApproverSequence = '';
		this.approvalStateId  = '';
		this.approvalStateName = '';
		this.documentId = '';
		this.status = '';
		this.originatorId  = '';
		this.originatorFirstName = '';
		this.approvalStructureId  = '';
		this.approvalStructureName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			approvalTag : '0',
			approvalConfigurationId : '0',
			approvalConfigurationName : '0',
			approvalConfigurationInstanceId : '0',
			approvalConfigurationInstanceName : '0',
			approvalTypeId : '0',
			approvalTypeName : '0',
			currentApproverSequence : '0',
			approvalStateId : '0',
			approvalStateName : '0',
			documentId : '0',
			status : '0',
			originatorId : '0',
			originatorFirstName : '0',
			approvalStructureId : '0',
			approvalStructureName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}